import {ColorStep} from './types';

const PROFILE_PROGRESS_THRESHOLDS = {
	LOW: 25,
	MEDIUM: 50,
	HIGH: 75,
	MAX: 100,
} as const;

const PROFILE_PROGRESS_COLORS = {
	RED: {r: 211, g: 47, b: 47},
	ORANGE: {r: 255, g: 167, b: 38},
	GREEN: {r: 34, g: 186, b: 116},
	MAX: {r: 25, g: 135, b: 84},
} as const;

const CIRCULAR_PROGRESS_RADIUS = 18;
const CIRCULAR_PROGRESS_STROKE_WIDTH = 4;

const CIRCULAR_PROGRESS_CIRCUMFERENCE = 2 * Math.PI * CIRCULAR_PROGRESS_RADIUS;

const COLOR_STEPS: ColorStep[] = [
	{
		start: 0,
		end: PROFILE_PROGRESS_THRESHOLDS.LOW,
		from: PROFILE_PROGRESS_COLORS.RED,
		to: PROFILE_PROGRESS_COLORS.RED,
	},
	{
		start: PROFILE_PROGRESS_THRESHOLDS.LOW,
		end: PROFILE_PROGRESS_THRESHOLDS.MEDIUM,
		from: PROFILE_PROGRESS_COLORS.RED,
		to: PROFILE_PROGRESS_COLORS.ORANGE,
	},
	{
		start: PROFILE_PROGRESS_THRESHOLDS.MEDIUM,
		end: PROFILE_PROGRESS_THRESHOLDS.HIGH,
		from: PROFILE_PROGRESS_COLORS.ORANGE,
		to: PROFILE_PROGRESS_COLORS.GREEN,
	},
	{
		start: PROFILE_PROGRESS_THRESHOLDS.HIGH,
		end: PROFILE_PROGRESS_THRESHOLDS.MAX,
		from: PROFILE_PROGRESS_COLORS.GREEN,
		to: PROFILE_PROGRESS_COLORS.MAX,
	},
];

export {
	PROFILE_PROGRESS_THRESHOLDS,
	PROFILE_PROGRESS_COLORS,
	CIRCULAR_PROGRESS_RADIUS,
	CIRCULAR_PROGRESS_STROKE_WIDTH,
	CIRCULAR_PROGRESS_CIRCUMFERENCE,
	COLOR_STEPS,
};
